/* eslint-disable no-unused-vars */
import { createTheme, PaletteColorOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
	interface CustomPalette {
		anger: PaletteColorOptions;
		customBlack: PaletteColorOptions;
		customYellow: PaletteColorOptions;
	}
	type Palette = CustomPalette;
	type PaletteOptions = CustomPalette;
}

declare module '@mui/material/Button' {
	// eslint-disable-next-line no-shadow
	interface ButtonPropsColorOverrides {
		anger: true;
		customBlack: true;
		customYellow: true;
	}
}

export const index = createTheme({
	palette: {
		primary: {
			main: '#e34c14',
			contrastText: '#FFFFFF',
		},
		secondary: {
			main: '#FFFFFF',
			dark: '#E5E5E5',
			light: '#e34c14',
		},
	},
	typography: {
		fontFamily: 'Inter, sans-serif',
		fontSize: 16,
		h1: {
			fontFamily: 'Orbitron, sans-serif',
		},
		h2: {
			fontFamily: 'Orbitron, sans-serif',
		},
		h3: {
			fontFamily: 'Orbitron, sans-serif',
		},
		h4: {
			fontFamily: 'Orbitron, sans-serif',
		},
		h5: {
			fontFamily: 'Orbitron, sans-serif',
		},
		h6: {
			fontFamily: 'Orbitron, sans-serif',
		},
		button: {
			textTransform: 'none',
			whiteSpace: 'nowrap',
		},
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 360,
			md: 600,
			lg: 1450,
			xl: 1800,
		},
	},
});
